module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('em', [_vm._v("Transliterations")])])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_c('strong', [_vm._v("Hebrew")])]), _vm._v(" "), _c('table', {
    staticClass: "table-l"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("א")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_c('span', {
    staticClass: "char-i"
  }, [_vm._v("ʾ")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ב")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("b")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ג")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("g")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ד")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("d")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ה")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("h")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ו")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("w")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ז")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("z")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ח")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_c('span', {
    staticClass: "char-i"
  }, [_vm._v("ḥ")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ט")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_c('span', {
    staticClass: "char-i"
  }, [_vm._v("ṭ")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("י")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("y")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ך")]), _vm._v(" ,"), _c('span', {
    staticClass: "heb"
  }, [_vm._v("כ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("k")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ל")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("l")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ם")]), _vm._v(" ,"), _c('span', {
    staticClass: "heb"
  }, [_vm._v("מ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("m")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ן")]), _vm._v(" ,"), _c('span', {
    staticClass: "heb"
  }, [_vm._v("נ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("n")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ס")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("s")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ע")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_c('span', {
    staticClass: "char-i"
  }, [_vm._v("ʿ")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ף")]), _vm._v(" ,"), _c('span', {
    staticClass: "heb"
  }, [_vm._v("פ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("p")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("צ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_c('span', {
    staticClass: "char-i"
  }, [_vm._v("ṣ")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ק")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("q")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ר")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("r")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("שׂ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ś")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("שׁ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("š")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ת")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("t")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("No distinction is made between the "), _c('em', [_vm._v("bgdkpt")]), _vm._v(" with or without the dagesh lene.")]), _vm._v(" "), _c('p', {
    staticClass: "para0"
  }, [_vm._v("Compare: "), _c('span', {
    staticClass: "heb"
  }, [_vm._v("תּוֹרָה")]), _vm._v(" = "), _c('em', [_vm._v("tôrâ")])]), _vm._v(" "), _c('p', {
    staticClass: "para0"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("הַתּוֹרָה")]), _vm._v(" = "), _c('em', [_vm._v("hattôrâ")])]), _vm._v(" "), _c('p', {
    staticClass: "para0"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("תּוֹרָתוֹ")]), _vm._v(" = "), _c('em', [_vm._v("tôrātô")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-head"
  }, [_c('strong', [_vm._v("Vowels")])]), _vm._v(" "), _c('table', {
    staticClass: "table-l"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ה ָ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("â")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ָ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ā")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ַ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("a")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ֲ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ă")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ֵ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ē")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("י ֵ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ê")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ֶ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("e")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ְ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ĕ")]), _vm._v(" (if vocal)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ֱ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ĕ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ִ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("i")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("י ִ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("î")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("וֹ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ô")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ֹ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ō")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ָ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("o")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ֳ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ŏ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("וּ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("û")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("ֻ")])])]), _vm._v(" "), _c('td', {
    staticClass: "tr"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("=")])]), _vm._v(" "), _c('td', {
    staticClass: "tr2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("u")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0065f396","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009_Transliterations.vue
// module id = 81
// module chunks = 0